export default __webpack_public_path__ + "static/media/About3.6a18cf68.jpg";